import { phoneNumber, phoneNumberLink } from 'utils/helpers';

export const bookingFormFallbackRender = () => (
  <p className="m-3">
    There&apos;s been an error. Please contact us on{' '}
    <a href={`tel:${phoneNumberLink}`}>{phoneNumber}</a> if you wish to book
    this product.
  </p>
);
